module.exports = __webpack_public_path__ + "static/header-pic-7d2e3cc7c34ca703b2d412e9848008ac.jpeg";